import React, { Component } from 'react';

import { FormSpy } from 'react-final-form';
import get from 'lodash/get';
import isEmpty from 'lodash/isEmpty';

class AutoFillSpyComponent extends Component {
  
  componentWillReceiveProps (nextProps){
    if (nextProps.values === this.props.values)
      return
    
    const { from, to, values, form, parse } = nextProps
    const fromValue = get(values || {}, from);
    const previousFromValue = get(this.props.values || {}, from);
    
    if (fromValue === previousFromValue)
      return
    
    const toValue = get(values || {}, to);
    
    if (isEmpty(toValue) || this.previousToValue === toValue || typeof parse === 'function'){
      if (typeof parse === 'function'){
        form.change(to, parse(fromValue, toValue));
      }
      else
        form.change(to, fromValue)
      this.previousToValue = fromValue
    }
  }
  
  render (){
    return null
  }
}

const AutoFillSpy = (props) => (
  <FormSpy
    {...props}
    subscription={{values: true}}
    component={AutoFillSpyComponent}
  />
)


export default AutoFillSpy;


// WEBPACK FOOTER //
// ./src/components/form/AutoFillSpy.js